<template>
    <div class="view" ref="chart"></div>
</template>

<script>
  export default {
    name: "bar",
    props: [
      'title',
      'dataset',
      'type',
      'xAxisAxisLabelFontSize'
    ],
    data() {
      return {
        option: {},
        echartInstance: ''
      }
    },
    created() {
      this.option = {
        title: {
          left: 26,
          top: 32,
          text: this.title.text,
          subtext: this.title.subText,
          itemGap: 4,
          textStyle: {
            color: '#454B60',
            fontSize: 26,
            fontWeight: 'bold',
            lineHeight: 26
          },
          subtextStyle: {
            color: '#999999',
            fontSize: 12,
            fontFamily: 'Microsoft YaHei'
          }
        },
        grid: {
          left: 30,
          top: 136,
          right: 44,
          bottom: 30,

          containLabel: true
        },
        legend: {
          top: 28,
          right: '30',
          y: 'center',
          itemWidth: 18,
          itemHeight: 24,
          itemGap: 10,
          icon: 'diamond',//'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
          itemStyle: {},
          formatter: (value) => {
            return '{value1|' + value + '}'
          },
          textStyle: {
            rich: {
              value1: {
                height: 38,
                lineHeight: 38,
                padding: [0, 6],
                color: '#999999',
                fontSize: 14,
                backgroundColor:''
              }
            }
          }
        },
        tooltip: {},
        dataset: this.dataset || {source: []},
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            color: '#999999',
            fontSize: this.xAxisAxisLabelFontSize || 14,
            margin: 12
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#F1F1F1',
              width: 2
            }
          },
          axisLine: {
            lineStyle: {
              color: '#F1F1F1',
              width: 2
            }
          }
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            margin: 30,
            formatter: (value) => {
              return [
                "{value1|" + value + "}"
              ]
            },
            rich: {
              value1: {
                color: '#999999',
                fontSize: 14
              }
            }
          }
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [

        ]
      }
      this.option.series.forEach(item => {
        item.type = this.type
        item.itemStyle = {
          normal: {
            lineStyle: {
              width: 4
            }
          }
        }
      })
    },
    watch: {
      dataset: {
        handler: function (newVal) {
          this.option.dataset = newVal
          if(this.option.dataset.source.length >0){
            this.option.series = []
            for(let i=0;i<this.option.dataset.source.length-1;i++){
              this.option.series.push({
                type:this.type,
                seriesLayoutBy: "row",
                smooth: true,
                symbol: 'circle',

                itemStyle : {
                  normal: {
                    lineStyle: {
                      width: 3
                    }
                  }
                }
              })
            }
          }
          this.$nextTick(() => {
            this.echartInstance.setOption(this.option)
          })
        },
        deep: true
      }
    },
    mounted() {
      this.echartInstance = this.$chart.init(this.$refs['chart'])
      this.echartInstance.setOption(this.option)
    }
  }
</script>

<style scoped lang="scss">
    .view {
        width: 100%;
        height: 388px;
    }
</style>
